import axios from 'axios';

export function getFAQs({ courseId, searchQuery = '' }) {
  return (dispatch) => {
    return axios
      .get('/api/faqs/getFAQs', { params: { courseId, searchQuery } })
      .then((res) => res.data);
  };
}

/**
 * The headings, in display order, from the server.
 *
 * FETCHED, NOT DECLARED HERE. The list and its order live in the server's
 * config/faqCategories.js and are served precisely so the client does not keep
 * a second copy - the same duplication that put the reading-rule copy in two
 * places and the criteria labels in two more.
 *
 * `set` exists for the course-specific list teachers may get later. An unknown
 * set returns [], which renders an ungrouped list rather than breaking.
 */
export function getFAQCategories(set = 'general') {
  return (dispatch) => {
    return axios
      .get('/api/faqs/getFAQCategories', { params: { set } })
      .then((res) => res.data.categories || []);
  };
}

export function addFAQ(faq) {
  return (dispatch) => {
    return axios.post('/api/faqs/addFAQ', faq);
  };
}

export function updateFAQ(faq) {
  return (dispatch) => {
    return axios.put(`/api/faqs/updateFAQ/${faq._id}`, faq);
  };
}

export function deleteFAQ(faqId) {
  return (dispatch) => {
    return axios.delete(`/api/faqs/deleteFAQ/${faqId}`);
  };
}

export function updateFAQOrders(data) {
  return (dispatch) => {
    return axios.put('api/faqs/updateFAQOrders', data);
  };
}
